import { useSearchParams } from 'react-router-dom';

import { KEY_PARAM_MODAL, MODAL_NAMES } from '#client/constants/modals';

const modalNames = Object.values(MODAL_NAMES);

export default function useCheckOpenModal() {
  const [searchParams] = useSearchParams();
  const modalName = searchParams.get(KEY_PARAM_MODAL);
  const isOpeningModal = modalNames.includes(modalName);

  /**
   *
   * This function is used to check if a modal is opening except some modal names
   * @param {*} modalNamesToExclude - Array of modal names to exclude
   * @returns {boolean} - True if the modal is opening except the modal names to exclude
   */
  const checkIsOpeningModalExcept = (modalNamesToExclude) => {
    if (!modalNamesToExclude || !modalNamesToExclude.length) {
      return isOpeningModal;
    }
    const modalNamesToCheck = modalNames.filter((name) => !modalNamesToExclude.includes(name));
    return modalNamesToCheck.includes(modalName);
  };

  return {
    isOpeningModal,
    checkIsOpeningModalExcept
  };
}
